import { Component, OnInit } from '@angular/core';
import { AnalysisService } from '../services/analysis.service';

@Component({
  selector: 'lib-analysis',
  template: ` <router-outlet></router-outlet> `,
  styles: [],
})
export class AnalysisComponent implements OnInit {
  constructor(private service: AnalysisService) {}

  ngOnInit(): void {
    this.service.sample().subscribe(console.log);
  }
}
